module.exports = __webpack_public_path__ + "static/media/mada.6268b861.png";